import { Configuration } from "@azure/msal-browser";

export const scopes = [
  `api://${import.meta.env.VITE_AZURE_BACKEND_CLIENT_ID}/shop.user`,
];

export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_AZURE_TENANT_ID}`,
    redirectUri: "/",
    postLogoutRedirectUri: "/",
  },
  system: {},
};
